<template>
    <div class="pay">
        <div class="form">
            <div class="top">
                <p>{{ activity.name }}</p>
            </div>
            <div class="box">
                <div class="title">
                    消费金额
                </div>
                <div class="money">
                    <span>¥</span>
                    <div class="input">
                        <span>{{ value }}</span>
                        <div class="cursor"></div>
                    </div>
                </div>
                <button
                    :class="[this.value=='' ? 'error' :'success','button']"
                    :disabled="this.value==''"
                    @click="submit">
                    确认付款
                </button>
                <div class="tag" @click="openNote" ref="note">
                    {{ note == '' ? '添加付款备注' : note }}
                </div>
            </div>
        </div>

        <van-number-keyboard
            :show="show"
            v-model="value"
            maxlength="10"
            extra-key="."/>

        <van-popup v-model="popup" @click-overlay="w">
            <div class="popup-box">
                <div class="title">添加付款备注</div>
                <div class="note">
                    <input type="text" maxlength="20" placeholder="商家可见,最多20个字" v-model="note" ref="input"/>
                </div>
                <div class="button-group">
                    <button style="border-right: 1px solid #dedede;" @click="cancel();note=''">取消</button>
                    <button style="color:#52c753" @click="cancel">确定</button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import weChatPay from "../wechat/weChatPay"
import weChatShare from "@/wechat/wxchatShare"

export default {
    created() {
        this.$axios.get(
            "get_act_info", {
                params: {
                    qrcode_id: this.$route.query.q_id
                }
            }
        ).then(res => {
            if (res.code == 1) {
                this.activity = res.data
                weChatShare({title: this.activity.name})
            }
            if (res.code == 5001) {
                this.$router.push({path: '/end', query: {text: res.message}})
            }
        })
    },
    data() {
        return {
            show: true,
            value: '',
            popup: false,
            note: '',
            timer: true,//防止多次点击
            activity: {},//活动信息
        }
    },
    methods: {
        //付款
        submit() {
            this.$toast.loading({
                forbidClick: true,
                message: '微信支付中'
            })
            if (this.value.endsWith('.')) {
                this.value = this.value + '00'
            }
            if (this.timer) {
                this.timer = false
                let query = this.$route.query
                this.$axios.post("create", {
                    money: parseFloat(this.value),
                    remark: this.note,
                    activity_id: parseInt(query.a_id),
                    rec_qrcode_id: parseInt(query.q_id),
                    promoter_id: parseInt(query.p_id),
                    channel_id: parseInt(query.c_id),
                    salesman_id: parseInt(query.s_id),

                }).then(res => {
                    this.timer = true
                    this.$toast.clear();
                    if (res.code == 1) {
                        let order_sn = res.data.order_sn
                        weChatPay({
                            wxPayConfig: res.data.payConfig,
                            onSuccess: () => {
                                window.location.href = '/success?order_sn=' + order_sn
                            }
                        })
                    } else {
                        this.$toast(res.message)
                    }
                })
            }

        },
        w() {
            this.show = true
        },
        openNote() {
            this.popup = true
            this.show = false
            setTimeout(() => {
                this.$refs.input.focus()
            }, 500)
        },
        cancel() {
            this.popup = false
            this.$refs.input.blur()
            //兼容苹果

            setTimeout(() => {
                this.show = true
            }, 500)
        }
    },
    watch: {
        value(value) {
            let num = value.match(/\./g)
            //当小数点超过两位，自动屏蔽
            if (num != null && num.length > 1) {
                this.value = value.slice(0, value.length - 1)
            }
            if (value.includes(".")) {
                //如果小数点在前，自动加0
                if (value.indexOf('.') == 0) {
                    this.value = '0.'
                }
                //限制小数点后两位
                let num = value.indexOf('.')
                let fixed = value.slice(num + 1)
                if (fixed.length > 2) {
                    this.value = value.slice(0, num + 1) + fixed.slice(0, 2)
                }
            }
            //如果以0开头，阻止连续输入两个0以上
            if (value.startsWith("00")) {
                this.value = '0'
            }
            //限制金额
            if (value.length > 7) {
                if (parseInt(value) > 9999999) {
                    this.value = value.slice(0, 7)
                }
            }
        }
    }

}
</script>

<style scoped lang="less">
.pay {
    width: 100%;
    height: 100vh;
    background-color: #efeff1;
    padding-top: 15px;
    box-sizing: border-box;
}

.form {
    width: 92%;
    box-sizing: border-box;
    padding-top: 50px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 5px;

    .top {
        padding: 0px 20px;

        p {
            font-size: 14px;
            color: #232323;
            font-weight: 700;
        }
    }

    .box {
        background-color: white;
        width: 100%;
        margin-top: 30px;
        padding: 20px 20px 30px;
        box-sizing: border-box;

        .title {
            font-size: 12px;
            color: #b3b3b3;
        }

        .money {
            margin-top: 18px;
            padding-bottom: 18px;
            border-bottom: 1px solid #f4f4f4;
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 27px;
            height: 32px;

            .input {
                display: flex;
                margin-left: 5px;
                height: 100%;

                .cursor {
                    width: 1px;
                    height: 100%;
                    background-color: #96dd8e;
                    margin-left: 2px;
                    animation: cursor 1s linear infinite;
                }
            }

        }

        .button {
            width: 100%;
            border: none;
            padding: 10px 0px;
            margin-top: 21px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 700;
        }

        .error {
            background-color: #aadda5;
            color: #d6f0d0;
        }

        .success {
            background-color: #3ee185;
            color: white;
        }

        .tag {
            font-size: 12px;
            text-align: center;
            margin-top: 27px;
            color: #7d8596;
        }
    }
}

.popup-box {
    padding-top: 20px;
    width: 70vw;

    .title {
        font-size: 14px;
        text-align: center;
        color: #232323;
        margin-bottom: 20px;
    }

    .note {
        padding: 0px 15px;
        box-sizing: border-box;
        margin-bottom: 20px;

        input {
            font-size: 12px;
            width: 100%;
            padding: 7px 4px;
            box-sizing: border-box;
            border: 1px solid #e8e8e8;
            border-radius: 5px;
            -webkit-appearance: none;
        }
    }

    .button-group {
        border-top: 1px solid #dedede;
        display: flex;

        button {
            flex: 1;
            border: none;
            font-size: 14px;
            padding: 13px 0px;
            background-color: white;
        }
    }
}

@keyframes cursor {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    55% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}
</style>
